import { getContext, setContext } from "svelte";
import { writable, type Writable } from "svelte/store";
import type { FolderPermissions } from "./types";
const context_key = {};

type StoreProps = FolderPermissions & {
	folderId: string;
};

type FolderPermissionsStore = Writable<StoreProps>;

export function getFolderPermissions() {
	const store = getContext(context_key) as FolderPermissionsStore;
	if (!store) {
		throw new Error("You should call 'setFolderPermissions' first");
	}

	return store;
}

export function setFolderPermissions(permissions: StoreProps) {
	let store = getContext(context_key) as FolderPermissionsStore;
	if (!store) {
		store = writable<StoreProps>(permissions);
		setContext(context_key, store);
	} else {
		store.update((value) => {
			return {
				...value,
				...permissions
			};
		});
	}
	return store;
}
